import { render, staticRenderFns } from "./QuizEdit.vue?vue&type=template&id=3a05a538&"
import script from "./QuizEdit.vue?vue&type=script&lang=js&"
export * from "./QuizEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports